import React from 'react';
import SubPageTemplate from '../components/SubPageTemplate';

const SolutionB = () => {
  const features = [
    { title: 'Lead Intelligence', description: 'AI-powered lead scoring and insights' },
    { title: 'Smart Outreach', description: 'Personalized at scale' },
    { title: 'Pipeline Management', description: 'Visual, intelligent tracking' },
    { title: 'Automated Follow-ups', description: 'Never miss an opportunity' },
    { title: 'Performance Analytics', description: 'Data-driven decisions' },
    { title: 'CRM Integration', description: 'Works with your tools' },
  ];

  return (
    <SubPageTemplate
      title="Sales"
      description="Intelligent sales automation that helps you close more deals faster."
      features={features}
    />
  );
};

export default SolutionB;
